import React, { useEffect, useState } from 'react';
import config from '../config';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './login.css'; // Import the CSS file

const Login = () => {
	const [backgroundImage, setBackgroundImage] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		// Fetch a random image if needed (uncomment if you want to use it)
		// fetchRandomImage();

		const loadGoogleScript = () => {
			const script = document.createElement('script');
			script.src = 'https://accounts.google.com/gsi/client';
			script.async = true;
			script.defer = true;
			document.body.appendChild(script);

			script.onload = () => initializeGoogleSignIn(config.GOOGLE_CLIENT_ID);
		};

		const initializeGoogleSignIn = (clientId) => {
			window.google.accounts.id.initialize({
				client_id: clientId,
				callback: handleCredentialResponse
			});
			window.google.accounts.id.renderButton(
				document.getElementById('googleSignInDiv'),
				{ theme: 'outline', size: 'large' }
			);
		};

		loadGoogleScript();
	}, []); // Ensure the dependency array is correct

	const handleCredentialResponse = async (response) => {
		const { credential } = response;
		
		// Decode the JWT token
		const decodedToken = JSON.parse(atob(credential.split('.')[1]));
		
		console.log("Decoded token:", decodedToken);

		try {
			// Send the decoded token to your server

			const apiUrl = config.API_BASE_URL;
			const serverResponse = await axios.post(`${apiUrl}/Users/Saveuser`, decodedToken);
			console.log('Server response:', serverResponse.data);
			const user = serverResponse.data;
			
			// Ensure isAdmin is included in the user object
			if (user.isAdmin === undefined) {
				console.error("isAdmin field is missing from the user object");
				// You might want to set a default value or handle this case appropriately
				user.isAdmin = false; // Default to non-admin if not specified
			}

			// Store user info in localStorage
			localStorage.setItem('user', JSON.stringify(user));
			localStorage.setItem('userEmail', user.email);

			if (user.mobile === null && user.company === null) {
				console.log("User is not complete");
				navigate('/CompleteProfile', { state: { user } }); 
				setTimeout(() => {
					if (window.location.pathname !== '/CompleteProfile') {
						console.log("Fallback: using window.location");
						// Note: We can't pass state with window.location, so you'll need to handle this in TicketList
						window.location.href = '/CompleteProfile';
					}
				}, 100);
			} else {
				console.log("Attempting to navigate to ticket list");
				console.log("User object:", user); // Log the entire user object for debugging
				navigate('/tickets', { 
					state: { user: user, isAdmin: user.isAdmin }
				});
				console.log("Navigation function called");
				
				// Fallback: use window.location if navigate doesn't work
				setTimeout(() => {
					if (window.location.pathname !== '/tickets') {
						console.log("Fallback: using window.location");
						// Note: We can't pass state with window.location, so you'll need to handle this in TicketList
						window.location.href = '/tickets';
					}
				}, 100);
			}
			
		} catch (error) {
			console.error('Error sending data to server:', error);
			// Handle error (e.g., show error message to user)
		}
	};

	return (
		<div className="login-page">
			<nav className="top-nav">
				<div className="nav-content">
					<div className="nav-logo">{config.APP_NAME}</div>
					<div className="nav-links">
						
					</div>
				</div>
			</nav>

			<div className="auth-wrapper">
				<div className="auth-inner">
					<h3>Login using Google Account</h3>
					<form>
						<div id="googleSignInDiv"></div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default Login;
